import { render, staticRenderFns } from "./vcHeader.vue?vue&type=template&id=9f84b7ea&scoped=true&"
import script from "./vcHeader.vue?vue&type=script&lang=js&"
export * from "./vcHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84b7ea",
  null
  
)

export default component.exports